import { core } from 'types';
import { toJSONArray } from '@tock/coretypes';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

interface InitialState {
  isInitialized: boolean;
  isUpserting: boolean;
  isLoadingTicketTypes: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: any;
  selectedBusinessTicketTypes: core.TicketType[];
}

const initialState: InitialState = {
  isInitialized: false,
  isUpserting: false,
  isLoadingTicketTypes: false,
  response: null,
  selectedBusinessTicketTypes: [],
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.IMPORT_UPLOAD_DONE: {
      return {
        ...state,
        isInitialized: true,
        isUpserting: false,
        response: payload,
      };
    }
    case ClowncarAppConstants.IMPORT_UPLOAD_STARTING: {
      return {
        ...state,
        isInitialized: false,
        isUpserting: true,
      };
    }
    case ClowncarAppConstants.IMPORT_UPLOAD_FAILED: {
      return {
        ...state,
        isInitialized: false,
        isUpserting: false,
      };
    }
    case ClowncarAppConstants.IMPORT_FETCH_TICKET_TYPES_STARTING: {
      return {
        ...state,
        isLoadingTicketTypes: true,
        selectedBusinessTicketTypes: [],
      };
    }
    case ClowncarAppConstants.IMPORT_FETCH_TICKET_TYPES_FAILED: {
      return {
        ...state,
        isLoadingTicketTypes: false,
        selectedBusinessTicketTypes: [],
      };
    }
    case ClowncarAppConstants.IMPORT_FETCH_TICKET_TYPES_DONE: {
      return {
        ...state,
        isLoadingTicketTypes: false,
        selectedBusinessTicketTypes: toJSONArray<core.TicketType>(payload),
      };
    }
    default:
      return state;
  }
}
